// extracted by mini-css-extract-plugin
export default {"row":"CompanyRow_row__0SmVE font-sm-regular"};